import { ContextMenuItem } from '@cad-arc';
import { useAddAssignedUnitsApi } from '../use-add-assiged-units-api';

export function AssignToEventItem({
    unitId,
    agencyEventId,
}: {
    unitId: number;
    agencyEventId: number;
}): React.ReactElement {
    const addAssignedUnits = useAddAssignedUnitsApi();
    return (
        <ContextMenuItem
            onSelect={() => addAssignedUnits({ eventId: agencyEventId, unitIds: [unitId] })}
        >
            Assign To Event
        </ContextMenuItem>
    );
}
